<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="560"
           :class-name="z100000"
           class="mask "
    >
      <h3 slot="header" class="modal-header">组织机构</h3>
      <div class="content mb16">
        <Input placeholder="搜索" @on-change="setTreeData"
               v-model="searchText"
        />
        <Tree :data="treeData" :multiple="true" ref="tree"
              @on-select-change="selectChange"
        ></Tree>
      </div>
    </Modal>
  </div>

</template>
<script>
  import {organTree} from "../../../../api/systemmanage";
  import {setTitleSelectedAndLevel, filterArr, setSelectedFromData} from "../../js/systemmanage";

  export default {
    name: "",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      valueArrStr:{
        type:String,
        default:''
      },
    },
    watch: {
      n() {
        this.treeData = [];
        this.searchText = '';
        this.organTree();
        this.isShow = true
      }
    },
    data() {
      return {
        z100000: 'z100000',
        loading: true,
        isShow: false,
        treeData: [],
        data: [],
        searchText: '',
        selected:null
      }
    },
    methods: {
      clearSelected(arr){
        arr.forEach(ele=>{
          ele['selected']=false
          if(ele.children && ele.children.length && ele.level !== 1){
            this.clearSelected(ele.children)
          }
        })
      },
      selectChange(value){
        if(this.data[0].parentValue !== -1){
          //只有顶级是中心机构时才做二级不能多选的判断
          return
        }
        if(!this.selected ){
          value.length && ( this.selected=value)
          return
        }
        if(!value.length){
          this.selected=null
          return
        }
        //新选择的减少了一个则不需要判断
        if(this.selected.length > value.length){
          this.selected=value
          return
        }
        //只选了level===1的则不需要判断
        if(this.selected.length === 1 && this.selected[0].level === 1){
          this.selected=value
          return
        }
        //从已选中的节点中获取level2的value
        let levelTwoValue = ''
        for (let i=0; i<this.selected.length; i++){
          if(this.selected[i].level === 2){
            levelTwoValue  = this.selected[i].value
            break
          }else if(this.selected[i].level === 3){
            levelTwoValue  = this.selected[i].parentValue
            break
          }
        }
        //求新选中和旧选中两个数组的差集
        let difference = value.filter(item => !this.selected.includes(item));
        //执行判断
        for (let i=0; i<difference.length; i++){
          if(difference[i].level===1){
            continue
          }
          if(difference[i].level===2 && difference[i].value===levelTwoValue){
            continue
          }
          if(difference[i].level===3 && difference[i].parentValue===levelTwoValue){
            continue
          }
          else {
            this.clearSelected(this.selected)
          }
        }
        this.selected=value.filter(item => item.selected);
      },

      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      organTree() {
        return organTree().then(res => {
          if (!res.data || !res.data.length) {
            return
          }
          let data = res.data;
          setTitleSelectedAndLevel(data, 1);
          if (this.valueArrStr.length > 0) {
            setSelectedFromData(data, this.valueArrStr)
          }
          data[0]['expand']=true
          this.data = data;
          this.treeData = this.data
        }).catch(error => {
        })
      },
      setTreeData: function () {
        if (!this.searchText) {
          this.treeData = this.data
        }
        else {
          this.treeData = filterArr(this.data, this.searchText)
        }
      },
      ok() {
        let selected = this.$refs['tree'].getSelectedNodes();

        let levelTwo = 0;
        let dataArr = [];

        function getSelected(data) {
          data.forEach(ele => {
            if (ele.selected && ele.level === 2) {
              levelTwo++
            }
            ele.selected && (dataArr.push({title: ele.title, value: ele.value}))
          })
        }

        getSelected(selected);
        if (this.data[0].parentValue === -1 && levelTwo > 1) {
          this.$Message.info('二级菜单只能选一个！');
          this.changeLoading();
          return
        }
        this.$emit('setTitleValueArr', dataArr);
        this.isShow = false
      },
      cancel() {
        this.isShow = false
      }
    }

  }
</script>

<style scoped>
  .content {
    height: 400px;
    overflow: auto;
    border: 1px solid #dcdcdc;
    width: 380px;
    margin: 0 auto;
    /*padding-left: 30px;*/
    padding: 10px;

  }

  .left, .right {
    height: 100%;
    overflow: auto;
  }

  .left {
    width: 200px;
    /*background: lightgray;*/
    border: 1px solid #dcdcdc;
    padding: 10px;
    box-sizing: border-box;
    margin-right: 20px;
  }

</style>
